'use client';

import { mockInsightData } from '@/shared/job/insight.dto';
import { ZangiaPlusInsightView } from './ZangiaPlusInsightView';
import { LOCKED_PREVIEW_JOB_TIME } from './insightCopy';
import { plusCopy } from './plusCopy';
import BuyPlusButton from './BuyPlusButton';
import { ZangiaPlusLockIcon } from './ZangiaPlusLockIcon';

export default function ZangiaPlusLockedComponent({
  isEnglish = false,
}: {
  isEnglish?: boolean;
}) {
  const t = isEnglish ? plusCopy.en : plusCopy.mn;
  return (
    <section className="relative my-6 overflow-hidden rounded-xl border border-gray-200 bg-white">
      <div className="pointer-events-none select-none blur-sm">
        <ZangiaPlusInsightView
          data={mockInsightData}
          jobTime={LOCKED_PREVIEW_JOB_TIME}
          isEnglish={isEnglish}
          mode="lockedPreview"
        />
      </div>
      <div className="absolute inset-0 flex items-center justify-center bg-white/50 px-4">
        <div className="text-center">
          <ZangiaPlusLockIcon variant="badge" />
          <h2 className="text-base font-semibold text-gray-900">
            {t.overlayTitle}
          </h2>
          <p className="mt-2 text-sm text-gray-500">{t.overlaySubtitle}</p>
          <BuyPlusButton isEnglish={isEnglish} />
        </div>
      </div>
    </section>
  );
} 
